import * as React from 'react';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const SearchCriteriaContext = React.createContext(new SearchCriteriaModel());
